<div class="row">
    <div class="col-12 col-md-6">
      <h4 translate>BASIC</h4>
      <lib-gung-text-input-horizontal gungTranslate="PIM_I18N.SE.TITLE" [(ngModel)]="pimProduct.i18n.se.title">
      </lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal gungTranslate="PIM_I18N.EN.TITLE" [(ngModel)]="pimProduct.i18n.en.title">
      </lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="PIM_I18N.SE.SUBTITLE"
        [(ngModel)]="pimProduct.i18n.se.subTitle"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="PIM_I18N.EN.SUBTITLE"
        [(ngModel)]="pimProduct.i18n.en.subTitle"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="PIM_SEQUENCE"
        [(ngModel)]="pimProduct.extra.pim.sequence"
      ></lib-gung-text-input-horizontal>
      <!--  -->
      <lib-gung-text-area-input-horizontal
        gungTranslate="NOTES"
        [rowsNumber]="5"
        [(ngModel)]="pimProduct.extra.pim.notes"
      ></lib-gung-text-area-input-horizontal>
    </div>
    <div class="col-12 col-md-6">
      <h4 translate>DESCRIPTION</h4>
      <div class="form-group">
        <label for="i18n.se.description" class="control-label" translate>PIM_I18N.SE.DESCRIPTION</label>
        <textarea
          rows="5"
          id="i18n.se.description"
          name="i18n.se.description"
          class="form-control"
          [(ngModel)]="pimProduct.i18n.se.description"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="i18n.en.description" class="control-label" translate>PIM_I18N.EN.DESCRIPTION</label>
        <textarea
          rows="5"
          id="i18n.en.description"
          name="i18n.en.description"
          class="form-control"
          [(ngModel)]="pimProduct.i18n.en.description"
        ></textarea>
      </div>
      <label for="typeahead-related-products">
        <h5 translate>OEM</h5>
      </label>
      <div class="input-group">
        <input type="text" class="form-control input-sm" [(ngModel)]="inputOEM" />
        <button type="button" class="btn btn-primary" (click)="addOption(inputOEM)" translate>ADD</button>
      </div>
      <div class="row" *ngIf="pimProduct.extra.pim.OEM">
        <div class="col-xs-12 col-sm-6 pt-2" *ngFor="let opt of pimProduct.extra.pim.OEM.split(',')">
          <div class="input-group">
            <input type="text" disabled="disabled" class="form-control input-sm" [value]="opt" />
            <button type="button" class="btn btn-danger" (click)="removeOption(opt)" translate>DELETE</button>
          </div>
        </div>
      </div>
    </div>
  </div>